module.exports = __webpack_public_path__ + "static/media/box-full.b2213d35.svg";